import React from 'react';

interface Icon3DCloudProps {
  size?: string;
}

const Icon3DCloud: React.FC<Icon3DCloudProps> = ({ size = 'w-6 h-6' }) => {
  return (
    <div className={`${size} relative inline-flex items-center justify-center`} style={{ perspective: '1000px' }}>
      <div 
        className="w-full h-full relative"
        style={{
          animation: 'float 4s ease-in-out infinite',
          transformStyle: 'preserve-3d'
        }}
      >
        <div 
          className="absolute w-3/5 h-2/5 rounded-full bg-gradient-to-br from-amber-300 to-amber-400 shadow-lg"
          style={{ left: '-5%', top: '20%', boxShadow: '6px 4px 10px rgba(0,0,0,0.2)' }}
        />
        <div 
          className="absolute w-2/3 h-1/2 rounded-full bg-gradient-to-br from-amber-400 to-amber-500 shadow-lg"
          style={{ left: '15%', top: '0%', boxShadow: '6px 4px 10px rgba(0,0,0,0.2)' }}
        />
        <div 
          className="absolute w-3/5 h-2/5 rounded-full bg-gradient-to-br from-amber-300 to-amber-400 shadow-lg"
          style={{ right: '-5%', top: '20%', boxShadow: '6px 4px 10px rgba(0,0,0,0.2)' }}
        />
        <style>{`
          @keyframes float {
            0%, 100% { transform: translateY(0px) rotateX(5deg); }
            50% { transform: translateY(-4px) rotateX(5deg); }
          }
        `}</style>
      </div>
    </div>
  );
};

export default Icon3DCloud;
